import RunReport from "./RunReport"


export const tableColumns = [    
    {
      name: "Client",
      selector: (row) => row.name,
      sortable: false,   
    },        
    {
      name: "Total Visits",
      selector: (row) => row.no_of_visits?.toFixed(0),
      sortable: false,
    },
    {
      name: "Total Hours",
      selector: (row) => row.no_of_hours?.toFixed(2),
      sortable: false,
    },
  ];

const VisitsByClient = () => {    
  return (
    <>
    <RunReport ReportID={4} tableColumns={tableColumns} reportName={"Visits By Client"}  />
    </>
  )
}

export default VisitsByClient